var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58984 0.537109C6.6519 0.537109 6.70052 0.553072 6.75391 0.59668C6.80583 0.639166 6.83536 0.685797 6.85059 0.753906V0.754883L7.05273 1.72168L7.1416 2.14941H11.2861C11.379 2.14943 11.4321 2.17438 11.4814 2.22363C11.5307 2.27287 11.5558 2.3255 11.5557 2.41699V8.86719C11.5557 8.96003 11.5297 9.01321 11.4805 9.0625C11.4312 9.11177 11.3787 9.13693 11.2871 9.13672H7.11426C7.05211 9.13672 7.00367 9.12089 6.9502 9.07715C6.89738 9.03394 6.86754 8.98603 6.85254 8.91602L6.65234 7.95215L6.56348 7.52441H1.0752V12.8984C1.07518 12.9913 1.05022 13.0445 1.00098 13.0938C0.951739 13.143 0.8991 13.1681 0.807617 13.168C0.714594 13.1677 0.661125 13.1414 0.611328 13.0918C0.562641 13.0433 0.537123 12.9913 0.537109 12.8984V0.805664C0.537198 0.71304 0.562692 0.660772 0.611328 0.612305C0.648539 0.575271 0.687803 0.551687 0.744141 0.541992L0.807617 0.537109H6.58984Z",
    stroke: "#575757",
    strokeWidth: 1.07355
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.9f18451df2705a6823fc3358ff9c9751.svg";
export { ForwardRef as ReactComponent };